import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
var FileProgress = function FileProgress(_ref) {
  var progress = _ref.progress;
  if (!progress) {
    return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-spinner-scale",
      spin: true
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "progress"
  }, progress >= 100 ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "progress-bar",
    style: {
      width: "".concat(progress, "%")
    }
  }));
};
export default FileProgress;